
import { defineComponent } from 'vue';
import AdListItem from '@/ad/mixins/AdListItem';

export default defineComponent({
  name: 'AdTableRow',
  mixins: [AdListItem],
  emits: ['selected', 'hover'],
  props: {
    columns: Array,
  },
  computed: {
    isEstateAgency() {
      return this.ad.estateAgencyId;
    },
    landArea(): string {
      if (this.ad && (this.ad.estateType === 200 || this.ad.estateType === 300)) {
        return (this.ad.landArea / 100).toLocaleString();
      } else {
        return '';
      }
    },
  },
  methods: {
    onClick() {
      this.$emit('selected', this.ad);
    },
    onMouseOver() {
      this.$emit('hover', this.ad);
    },
    onMouseLeave() {
      this.$emit('hover', null);
    },
  },
});
